export const isLatitude = (x) => typeof x === 'number' && x > -90 && x < 90
export const isLongitude = (x) => typeof x === 'number' && x > -180 && x < 180
